import axios from "axios";
import { useEffect, useState } from "react";
import {
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaMapMarkerAlt,
  FaTiktok,
  FaYoutube,
} from "react-icons/fa";

const CACHE_KEY = "schoolDataCache";
const CACHE_TIME = 1000 * 60 * 10; // 10 menit

const Footer = () => {
  const [schoolData, setSchoolData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSchoolData = async () => {
      try {
        // ✅ 1. CEK CACHE
        const cached = localStorage.getItem(CACHE_KEY);

        if (cached) {
          const parsed = JSON.parse(cached);

          // cek apakah cache masih valid
          if (Date.now() - parsed.timestamp < CACHE_TIME) {
            setSchoolData(parsed.data);
            setLoading(false);
            return;
          }
        }

        // ✅ 2. FETCH API
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}api/datasekolah/all`,
        );

        if (res.data.length > 0) {
          const data = res.data[0];

          setSchoolData(data);

          // ✅ simpan ke cache
          localStorage.setItem(
            CACHE_KEY,
            JSON.stringify({
              data,
              timestamp: Date.now(),
            }),
          );
        }
      } catch (err) {
        console.error("Error fetch school data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSchoolData();
  }, []);

  if (loading) return null;
  if (!schoolData) return null;

  return (
    <footer className="bg-primary dark:bg-darkBg text-white mt-20">
      {/* ===== MAIN ===== */}
      <div className="max-w-7xl mx-auto px-6 py-12 grid gap-10 md:grid-cols-3">
        {/* School Info */}
        <div>
          <h2 className="font-bold text-lg mb-3">{schoolData.namasekolah}</h2>
          <p className="text-sm text-white/80">
            Website resmi sekolah dasar untuk informasi, berita, dan layanan
            akademik siswa.
          </p>
        </div>

        {/* Contact */}
        <div className="flex flex-col gap-4 text-sm">
          <div className="flex items-start gap-3">
            <FaMapMarkerAlt className="text-secondary mt-1" />
            <span className="text-white/90">{schoolData.alamat}</span>
          </div>

          <div className="flex items-center gap-3">
            <FaEnvelope className="text-secondary" />
            <span className="text-white/90">{schoolData.email}</span>
          </div>
        </div>

        {/* Social Media */}
        <div className="flex gap-6 items-center">
          {schoolData.linkInstagram && (
            <a href={schoolData.linkInstagram} target="_blank" rel="noreferrer">
              <FaInstagram
                className="hover:text-secondary transition"
                size={22}
              />
            </a>
          )}
          {schoolData.linkFacebook && (
            <a href={schoolData.linkFacebook} target="_blank" rel="noreferrer">
              <FaFacebook
                className="hover:text-secondary transition"
                size={22}
              />
            </a>
          )}
          {schoolData.linkYoutube && (
            <a href={schoolData.linkYoutube} target="_blank" rel="noreferrer">
              <FaYoutube
                className="hover:text-secondary transition"
                size={22}
              />
            </a>
          )}
          {schoolData.linkTiktok && (
            <a href={schoolData.linkTiktok} target="_blank" rel="noreferrer">
              <FaTiktok className="hover:text-secondary transition" size={22} />
            </a>
          )}
        </div>
      </div>

      {/* ===== BOTTOM ===== */}
      <div className="bg-secondary dark:bg-darkCard text-center py-4 text-sm text-black dark:text-gray-200">
        © {new Date().getFullYear()} {schoolData.namasekolah}. All rights
        reserved.
      </div>
    </footer>
  );
};

export default Footer;
